import {Component, HostListener, Renderer2} from '@angular/core';
import {NavigationService} from '../navigation/navigation.service';
import {BaseComponent} from '../base.component';
import {Router} from '@angular/router';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
})
export class LayoutComponent extends BaseComponent {

  constructor(
    public navigationService: NavigationService,
    public renderer: Renderer2,
    protected router: Router) {
    super(navigationService, router, renderer);
  }
}
